import { render } from "./UpsellModal.vue?vue&type=template&id=33f8964e&scoped=true"
import script from "./UpsellModal.vue?vue&type=script&lang=js"
export * from "./UpsellModal.vue?vue&type=script&lang=js"

import "./UpsellModal.vue?vue&type=style&index=0&id=33f8964e&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f8964e"]])

export default __exports__